import { BaseService } from "mrb/core";
import { NakiNigunImportApiRouteService } from "common/services";

class NakiNigunImportService extends BaseService {
    constructor(apiClient) {
        super(apiClient, new NakiNigunImportApiRouteService());
    }

    enableBatch(id, abortSignal = null) {
        const url = this.routeService.enable(id);
        return this.apiClient.put(url, null, null, abortSignal);
    }

    saveMetadata(id, payload, abortSignal = null) {
        const url = this.routeService.saveMetadata(id);
        return this.apiClient.put(url, payload, null, abortSignal);
    }

    addToSystem(id, abortSignal = null) {
        const url = this.routeService.addToSystem(id);
        return this.apiClient.post(url, null, null, abortSignal);
    }

    uploadArtwork(file, abortSignal = null) {
        const url = this.routeService.uploadArtwork();
        const formData = new FormData();
        formData.append("file", file);
        return this.apiClient.post(url, formData, null, abortSignal);
    }

    refresh(abortSignal = null) {
        const url = this.routeService.refresh();
        return this.apiClient.post(url, null, null, abortSignal);
    }

    discardBatch(id, abortSignal = null) {
        const url = this.routeService.discard(id);
        return this.apiClient.delete(url, null, null, abortSignal);
    }
}

export default NakiNigunImportService;
